import { useState, useEffect } from "react";
import "./FormContentDate.css";
import { Question, UpdateQuestionPayload } from "effno-core";
import { apiUpdateQuestion } from "../../services/QuestionService";
import { toastFail, toastSuccess } from "../../config";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { selectEditingForm, selectUIStates, setEditingForm } from "../../redux/features/appData";
import { useDispatch } from "react-redux";
import { DATE_FORMATS, DATE_SETTINGS, EMAIL_SETTINGS } from "../config/questionSettings";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { DEBOUNCE_TIME } from "../config/forms";
import { apiFormHasEdits } from "../../services/FormService";

type FormContentDateProps = {
    question: Question;
    allowSaving?: boolean;
}

export const FormContentDate = ({question, allowSaving = true} : FormContentDateProps) => {

    const dispatch = useDispatch();

    const editingForm = useSelector(selectEditingForm);

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [theDate, setTheDate] = useState<Date>(new Date());

    const [debouncedData, setDebouncedData] = useState<any | undefined>(undefined);
    const [debounceSettings, setDebounceSettings] = useState<any | undefined>(undefined);

    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);
    }, [question])

    // Debounce settings changes
    useEffect(() => {
        const handler = setTimeout(() => {
            if (!debounceSettings) {
                return;
            }
            setDebouncedData(debounceSettings);
        }, DEBOUNCE_TIME);

        // Clear the timeout if settings changes (i.e., user is still typing)
        return () => {
            clearTimeout(handler);
        };
    }, [debounceSettings]);

    // Effect to save the debounced data whenever it changes
    useEffect(() => {
        (async () => {
            if (!debouncedData) {
                return;
            }

            console.log("debouncedData: ", debouncedData);
            
            await handleSave();
        })()
    }, [debouncedData]);

    useEffect(() => {
        setDebounceSettings({
            title,
            description,
            theDate,
        })
    }, [title, description, theDate])

    const updateRedux = () => {
        if (!editingForm) {
            return;
        }

        const index = editingForm.questions.findIndex((q: Question) =>  q.id === question.id);

        if (index === -1) {
            toast("Can't find question id", toastFail);
            return;
        }

        const newQuestions = [...editingForm.questions];
        newQuestions[index] = {
            ...question,
            title,
            description
        };

        dispatch(setEditingForm({...editingForm, hasEdits: true, questions: newQuestions}));
    }

    const handleSave = async () => {
        if (!editingForm || !allowSaving) {
            return;
        }

        // update question in redux first to avoid delay lag causing issues
        updateRedux();

        const settings = question.settings ? JSON.parse(question.settings) : DATE_SETTINGS;

        const payload : UpdateQuestionPayload = {
            questionId: question.id,
            type: question.type,
            title: title,
            description: description,
            required: question.required,
            settings: JSON.stringify(settings),  // these don't change in this instance
            conditions: question.conditions
        }

        const newQuestion = await apiUpdateQuestion(payload);

        if (!newQuestion) {
            toast("Error saving update", toastFail);
            return;
        }

        await apiFormHasEdits(editingForm.id);
        console.log("Question updated");

        // update redux
        // const index = editingForm.questions.findIndex((q: Question) =>  q.id === question.id);

        // if (index === -1) {
        //     toast("Can't find question id", toastFail);
        //     return;
        // }

        // const newQuestions = [...editingForm.questions];
        // newQuestions[index] = newQuestion;

        // await apiFormHasEdits(editingForm.id);

        // dispatch(setEditingForm({...editingForm, hasEdits: true, questions: newQuestions}));

        // console.log("Question updated");

    }

    const settings = question.settings ? JSON.parse(question.settings) : {};
    let datePickerFormat = "MM/dd/yyyy";

    if (settings.dateFormat) {
        const index = DATE_FORMATS.findIndex((format) => format === settings.dateFormat);
        
        if (index !== -1) {
            datePickerFormat = ["MM/dd/yyyy", "dd/MM/yyyy", "yyyy/MM/dd"][index];
        }
    }

    return (
        <div className="form-content-body">
            <div className="form-content-title">
                <input 
                    type="text"
                    placeholder="..."
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    data-testid="question-title"
                />
                {/* {question.required && <span>*</span>} */}
            </div>
            <div className="form-content-description">
                <input 
                    type="text"
                    placeholder="Description (optional)"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    data-testid="question-description"
                />
            </div>   
            
            <div className="form-content-date">
                <DatePicker 
                    selected={theDate} 
                    dateFormat={datePickerFormat} 
                    onChange={(date) => {setTheDate(date as Date)}} 
                    className="form-content-date-picker-input"
                    wrapperClassName="form-content-date-picker-wrapper"
                />
            </div>    

            {/* <button 
                onClick={handleSave}
                data-testid="save-question"
            >
                temp save button before debounce 
            </button> */}
        </div>
    )
}